import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'RulerMeasureIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ruler-measure",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M19.875 12c.621 0 1.125 .512 1.125 1.143v5.714c0 .631 -.504 1.143 -1.125 1.143h-15.875a1 1 0 0 1 -1 -1v-5.857c0 -.631 .504 -1.143 1.125 -1.143h15.75z"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M9 12v2"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6 12v3"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 12v3"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M18 12v3"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M15 12v2"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3 3v4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3 5h18"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M21 3v4"
    }, null), _createTextVNode(" ")]);
  }
};